export class MenuItemEntity {
  name;
  action;
  hasDivider;
  icon;
  hasUtronColor;
  data;
  disabled;

  constructor(name = "", action = null, hasDivider = false, icon="", hasUtronColor=false, data=null, disabled = false) {
    this.name = name;
    this.action = action;
    this.hasDivider = hasDivider;
    this.icon = icon;
    this.hasUtronColor = hasUtronColor;
    this.data = data;
    this.disabled = disabled;
  }
}
